import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import {
  ContentStoreService,
  MxLoggerService,
  AuthStoreService,
  NavMenu,
  Promotion,
} from '@motivforce/mx-library-angular';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, skip, take } from 'rxjs/operators';
import { UserStoreService } from 'src/app/core/store/user-store.service';
import { environment } from 'src/environments/environment';

import { PromotionStoreService } from '../../../store/promotion-store.service';

@UntilDestroy()
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @ViewChild('header', { static: true }) headerElement: ElementRef<HTMLElement>;

  headerFixed = environment.headerFixed;

  authenticatedUser$ = this.authStore.authenticatedUser$.pipe(untilDestroyed(this));
  isWEPUser$ = this.userStore.isWEPUser$;
  intelPremiumRewardsId: number | null = null;

  headerMenu: NavMenu;
  enhancedHeaderMenu: NavMenu;

  promotion: Promotion;
  smarterSellerPromotionId: number | null = null;
  bigBangPromotionId: number | null = null;

  constructor(
    private authStore: AuthStoreService,
    private renderer: Renderer2,
    private contentStore: ContentStoreService,
    private mxLogger: MxLoggerService,
    private userStore: UserStoreService,
    private promotionStore: PromotionStoreService
  ) {}

  ngOnInit(): void {
    this.contentStore.headerMenu$.pipe(filter(Boolean)).subscribe((headerMenu) => {
      this.mxLogger.debug('HeaderComponent', 'ngOnInit() headerMenu=', headerMenu);

      const redeemBlocked = !!this.authStore.userSettings?.claims.find((claim) => claim === 'user.redeemBlocked');

      if (redeemBlocked) {
        headerMenu.items = headerMenu.items.filter((item) => !item.url.includes('rewards-catalogue'));
      }

      this.headerMenu = headerMenu;

      this.setEnhancedHeaderMenu();
    });

    this.promotionStore.promotions$.pipe(untilDestroyed(this), filter(Boolean)).subscribe((promotions) => {
      this.promotionStore.currentSmarterSeller$.pipe(skip(1), take(1)).subscribe((promotion: any) => {
        this.promotion = promotion;

        const smartSellerPromo = promotion;

        if (smartSellerPromo && !(smartSellerPromo.isApproved === false)) {
          this.smarterSellerPromotionId = smartSellerPromo.id;
        }
      });

      this.promotionStore.getAvailableUserSmartSellerPromotion();

      const intelPremiumRewardsPromo = promotions.find(
        (promotion) => promotion.description && promotion.description?.indexOf('Intel Premium Rewards') !== -1
      );
      if (intelPremiumRewardsPromo) {
        this.intelPremiumRewardsId = intelPremiumRewardsPromo.id;
      }

      const bigBangPromotionPromo = promotions.find(
        (promotion) => promotion.description && promotion.description?.indexOf('Score Big') !== -1
      );
      if (bigBangPromotionPromo) {
        this.bigBangPromotionId = bigBangPromotionPromo.id;
      }

      this.setEnhancedHeaderMenu();
    });
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(): void {
    if (environment.headerFixed) {
      if (window.scrollY > 0) {
        this.renderer.addClass(this.headerElement.nativeElement, 'scrolled');
      } else {
        this.renderer.removeClass(this.headerElement.nativeElement, 'scrolled');
      }
    }
  }

  private setEnhancedHeaderMenu(): void {
    this.enhancedHeaderMenu = this.headerMenu;

    if (this.smarterSellerPromotionId && this.headerMenu) {
      this.enhancedHeaderMenu = {
        ...this.enhancedHeaderMenu,
        items: [
          ...this.enhancedHeaderMenu.items,
          { url: `/promotions/${this.smarterSellerPromotionId}`, label: 'Smarter Seller Promotion' },
        ],
      };
    }

    if (this.intelPremiumRewardsId && this.headerMenu) {
      this.enhancedHeaderMenu = {
        ...this.enhancedHeaderMenu,
        items: [
          ...this.enhancedHeaderMenu.items,
          { url: `/promotions/${this.intelPremiumRewardsId}`, label: 'Intel Premium Rewards' },
        ],
      };
    }

    if (this.bigBangPromotionId && this.headerMenu) {
      this.enhancedHeaderMenu = {
        ...this.enhancedHeaderMenu,
        items: [
          ...this.enhancedHeaderMenu.items,
          { url: `/promotions/${this.bigBangPromotionId}`, label: 'Score big' },
        ],
      };
    }
  }
}
